// extracted by mini-css-extract-plugin
module.exports = {"landing":"LandingPage_landing__1RdQ8","title":"LandingPage_title__2-Ama","intro":"LandingPage_intro__2KxRj","button":"LandingPage_button__2I7Tw"};